var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 129.47 129.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #464648;\n      }\n\n      .cls-2 {\n        fill: #dfcda6;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-5 {\n        fill: #039;\n      }\n\n      .cls-3 {\n        fill: #eee5d1;\n      }\n\n      .cls-6 {\n        fill: #ffcc0c;\n      }\n\n      .cls-7, .cls-8 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        opacity: .08;\n      }\n\n      .cls-9 {\n        fill: none;\n      }\n\n      .cls-10 {\n        fill: #2d2d30;\n      }\n\n      .cls-11 {\n        fill: #0041a8;\n      }\n\n      .cls-12 {\n        isolation: isolate;\n      }\n\n      .cls-13 {\n        fill: #ececf5;\n      }\n\n      .cls-14 {\n        fill: #ffc742;\n      }\n\n      .cls-15 {\n        fill: #fae7b8;\n      }\n\n      .cls-16 {\n        fill: #af892e;\n      }\n\n      .cls-17 {\n        fill: #c7942c;\n        opacity: .47;\n      }\n\n      .cls-18 {\n        fill: #3852a5;\n      }\n\n      .cls-4 {\n        fill: #dcc89d;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-20 {\n        fill: #bf9c4e;\n      }\n\n      .cls-21 {\n        fill: #fce85c;\n        mix-blend-mode: overlay;\n      }\n\n      .cls-22 {\n        fill: #231f20;\n        opacity: .1;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 0,
    width: 129.47,
    height: 129.47
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 70.72,
    cy: 100.68,
    rx: 55.36,
    ry: 5.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 47.06,
    cy: 100.17,
    rx: 43.63,
    ry: 5.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.02,27.99s7.78-2.99,13.32-3.44,5.24,6.59,5.24,6.59l-15.12.75-3.44-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M73.41,58.15c-7.01-13.7-18.55-17.75-18.55-17.75,0,0,6.07-8.13,7.3-9.99,1.22-1.86-.39-2.15-3.53-1.62-2.59.45-7.31.63-8.87.68-1.56-.05-9.4-3.29-11.99-3.74-3.13-.54-4.75-.24-3.53,1.62,1.22,1.86,10.41,13.05,10.41,13.05,0,0-11.54,4.05-18.55,17.75-22.87,44.7,20.8,44.96,23.65,44.91,2.85.05,46.52-.21,23.65-44.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 38.86,
    cy: 64.27,
    rx: 12.79,
    ry: 7.99,
    transform: "translate(-35.15 77.08) rotate(-68.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M52.87,71.35c-.46,3.57-3.28,5.74-7.28,5.96,2.57,2.68,5.53,6.21,8.39,9.74h-4.75c-2.39-2.89-5.1-6.14-8.17-9.42v-3h2.11c3.39,0,5.17-1.32,5.53-3.28h-7.64v-2.18h7.49c-.54-1.61-2.14-2.53-4.89-2.53h-2.6v-3.1h15.81v2.18h-5.71c.89.82,1.5,1.96,1.71,3.46h4.03v2.18h-4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.61,54.89c7.4,18.35,8.64,47.61-38.73,41.46,8.46,6.66,21.37,6.73,22.88,6.7,2.85.05,46.52-.21,23.65-44.91-4.79-9.37-11.7-14.23-15.59-16.36l-1.37-.71-1.32.29s6.93,4.68,10.49,13.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M55.12,41.37s-1.6-1.01-1.89-1.18c-.29-.17.72-.35,3.21.89,2.49,1.24,2.82,2.1,2.86,2.14.04.04-4.19-1.85-4.19-1.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.6,40.57c6.22,2.97,6.62,9.78,5.93,15.6-.13,1.09-1.95,1.1-1.82,0,.62-5.19.58-11.43-5.03-14.11-1.05-.5-.13-1.98.92-1.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M51.09,40.48c-.47.34-.62,1.08.06,1.4,5.61,2.68,5.65,8.93,5.03,14.11-.07.61.46.88.97.81-.57.39-1.53.18-1.44-.63.62-5.19.58-11.43-5.03-14.11-.87-.42-.38-1.51.41-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.6,42.41c-1.97,2.24-2.43,5.17-2.82,7.96-.15,1.08-1.98,1.1-1.82,0,.47-3.31,1.03-6.54,3.36-9.18.75-.85,2.03.37,1.29,1.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M46.96,50.38c.47-3.31,1.03-6.54,3.36-9.18.35-.39.81-.34,1.13-.09-.24-.04-.5.03-.71.28-2.32,2.64-2.89,5.88-3.36,9.18-.04.28.05.48.2.62-.38-.06-.68-.33-.62-.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.98,
    y: 40.54,
    width: 13.91,
    height: 1.54,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(97.87 82.62) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.98,
    y: 39,
    width: 13.91,
    height: 1.54,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(97.87 79.54) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.98,
    y: 37.46,
    width: 13.91,
    height: 1.54,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(97.87 76.46) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.8,38.45h12.28c.35,0,.64-.21.76-.49.04.09.06.18.06.27,0,.42-.37.77-.82.77h-12.28c-.45,0-.82-.35-.82-.77,0-.1.02-.19.06-.27.12.29.41.49.76.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.8,40.02h12.28c.35,0,.64-.21.76-.49.04.09.06.18.06.27,0,.42-.37.77-.82.77h-12.28c-.45,0-.82-.35-.82-.77,0-.1.02-.19.06-.27.12.29.41.49.76.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.8,41.59h12.28c.35,0,.64-.21.76-.49.04.09.06.18.06.27,0,.42-.37.77-.82.77h-12.28c-.45,0-.82-.35-.82-.77,0-.1.02-.19.06-.27.12.29.41.49.76.49Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M112.19,102.64c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.2,102.33v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 104.67,
    y: 98.46,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 109.57,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 106.55,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 103.52,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 100.5,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 97.48,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 94.46,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 91.43,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 88.41,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 86.89,
    y: 98.46,
    width: 5.63,
    height: 3.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M112.89,97.82c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.9,97.52v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 105.37,
    y: 93.64,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 110.27,
    y: 93.64,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 107.25,
    y: 93.64,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 104.22,
    y: 93.64,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 101.2,
    y: 93.64,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 98.18,
    y: 93.64,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 95.16,
    y: 93.64,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 92.14,
    y: 93.64,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 89.11,
    y: 93.64,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87.59,
    y: 93.64,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 86.89,
    y: 98.46,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 87.59,
    y: 93.64,
    width: 5.63,
    height: 3.92
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M90.06,102.64c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.06,102.33v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.76,
    y: 98.46,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 82.54,
    y: 98.46,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 87.43,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 84.41,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.39,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 78.36,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 75.34,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 72.32,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 69.3,
    y: 98.46,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 66.27,
    y: 98.46,
    width: 0.48,
    height: 3.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M87.03,97.75c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.04,97.45v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.73,
    y: 93.58,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 79.51,
    y: 93.58,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 84.41,
    y: 93.58,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.39,
    y: 93.58,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 78.36,
    y: 93.58,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 75.34,
    y: 93.58,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 72.32,
    y: 93.58,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 69.3,
    y: 93.58,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 66.27,
    y: 93.58,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 63.25,
    y: 93.58,
    width: 0.48,
    height: 3.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M90.06,92.94c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.06,92.63v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.76,
    y: 88.76,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 82.54,
    y: 88.76,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 87.43,
    y: 88.76,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 84.41,
    y: 88.76,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.39,
    y: 88.76,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 78.36,
    y: 88.76,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 75.34,
    y: 88.76,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 72.32,
    y: 88.76,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 69.3,
    y: 88.76,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 66.27,
    y: 88.76,
    width: 0.48,
    height: 3.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M90.06,88.12c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.06,87.81v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.76,
    y: 83.94,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 82.54,
    y: 83.94,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 87.43,
    y: 83.94,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 84.41,
    y: 83.94,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.39,
    y: 83.94,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 78.36,
    y: 83.94,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 75.34,
    y: 83.94,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 72.32,
    y: 83.94,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 69.3,
    y: 83.94,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 66.27,
    y: 83.94,
    width: 0.48,
    height: 3.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M93.08,83.3c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.08,82.99v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 67.78,
    y: 79.12,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 85.56,
    y: 79.12,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 90.45,
    y: 79.12,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 87.43,
    y: 79.12,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 84.41,
    y: 79.12,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.39,
    y: 79.12,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 78.36,
    y: 79.12,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 75.34,
    y: 79.12,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 72.32,
    y: 79.12,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 69.3,
    y: 79.12,
    width: 0.48,
    height: 3.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M93.08,73.66c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.08,73.35v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 67.78,
    y: 69.48,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 85.56,
    y: 69.48,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 90.45,
    y: 69.48,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 87.43,
    y: 69.48,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 84.41,
    y: 69.48,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.39,
    y: 69.48,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 78.36,
    y: 69.48,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 75.34,
    y: 69.48,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 72.32,
    y: 69.48,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 69.3,
    y: 69.48,
    width: 0.48,
    height: 3.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M90.06,78.48c-.11.22-.34.38-.61.38h-24.7c-.27,0-.5-.15-.61-.38h25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.06,78.17v-3.44c0-.38.31-.69.69-.69h24.7c.38,0,.69.31.69.69v3.44c0,.11-.03.21-.07.31h-25.92c-.05-.09-.07-.2-.07-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.76,
    y: 74.3,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 82.54,
    y: 74.3,
    width: 5.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 87.43,
    y: 74.3,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 84.41,
    y: 74.3,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.39,
    y: 74.3,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 78.36,
    y: 74.3,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 75.34,
    y: 74.3,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 72.32,
    y: 74.3,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 69.3,
    y: 74.3,
    width: 0.48,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 66.27,
    y: 74.3,
    width: 0.48,
    height: 3.92
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M75.27,103.52c4.36-5.15,3.72-12.9-1.43-17.26-5.15-4.36-12.9-3.72-17.26,1.43-4.36,5.15-3.72,12.9,1.43,17.26,5.15,4.36,12.9,3.72,17.26-1.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 65.92,
    cy: 95.61,
    r: 11.9,
    transform: "translate(-50.21 94.93) rotate(-55.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.08,96.81l2.97-.3c.22,2.22,1.27,4.35,3.11,5.9,3.76,3.18,9.38,2.71,12.56-1.04,1.63-1.92,2.3-4.34,2.07-6.66l2.97-.3c.66,6.54-4.1,12.38-10.64,13.05-6.54.66-12.38-4.1-13.05-10.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 65.92,
    cy: 95.61,
    r: 8.91,
    transform: "translate(-50.08 101.11) rotate(-58.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.73,89.84c-3.76-3.18-9.38-2.71-12.56,1.04-1.39,1.64-2.09,3.65-2.11,5.65-.24-2.33.43-4.75,2.06-6.68,3.18-3.76,8.81-4.22,12.56-1.04,2.11,1.79,3.19,4.35,3.15,6.92-.23-2.21-1.28-4.33-3.11-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M57.08,96.69c.26,2.15,1.3,4.21,3.09,5.72,3.76,3.18,9.38,2.71,12.56-1.04,1.51-1.78,2.2-3.99,2.1-6.15.29,2.38-.37,4.87-2.04,6.84-3.18,3.76-8.81,4.22-12.56,1.04-1.97-1.67-3.04-4.02-3.14-6.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.44,94.76c.15,1.2-.58,2.15-1.86,2.56,1.06.65,2.33,1.55,3.56,2.46l-1.54.4c-1.02-.74-2.18-1.56-3.46-2.37l-.25-.98.69-.18c1.1-.29,1.57-.87,1.52-1.54l-2.49.65-.18-.71,2.44-.64c-.31-.48-.91-.64-1.81-.41l-.85.22-.26-1.01,5.15-1.34.18.71-1.86.48c.36.19.65.51.85.98l1.31-.34.18.71-1.31.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M66.97,94.76c.15,1.2-.58,2.15-1.86,2.56,1.06.65,2.33,1.55,3.56,2.46l-1.54.4c-1.02-.74-2.18-1.56-3.46-2.37l-.25-.98.69-.18c1.1-.29,1.57-.87,1.52-1.54l-2.49.65-.18-.71,2.44-.64c-.31-.48-.91-.64-1.81-.41l-.85.22-.26-1.01,5.15-1.34.18.71-1.86.48c.36.19.65.51.85.98l1.31-.34.18.71-1.31.34Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.cb366b215ca71ef5350b9e0f65c1b095.svg";
export { ForwardRef as ReactComponent };